import React, {Component} from 'react';

import {AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel,} from 'react-accessible-accordion';

import styled from "styled-components";
import {
  DownloadType,
  emptyCreateUserDownloadRequest,
  emptyVersion,
  ICreatePostFeedback,
  ICreateUserDownloadRequest,
  ICreateUserShareRequest,
  IFile,
  IFileHover,
  ISsqDataDocument,
  IVersion,
  NO_VERSION_TAG,
  SsqDataRepository
} from "repositories/SsqDataRepository";
import {formatSimpleDate} from "util/formatDateTime";
import download from "downloadjs";
import {LanguageService} from "language/LanguageService";
import CategoryStore, {ICategoryForSearch} from "../repositories/category/CategoryStore";
import {SsqImages} from "images/SsqImages";
import {DocLanguageType} from "definitions/DocLanguageType";
import {getFileSize} from "util/fileSize";
import {fontFamilyMedium, fontFamilyRegular} from "style/fonts";
import parse from "html-react-parser";
import {CommuFeedback, InputWrapForSelect} from "style/CommonStyledComponents";
import {EditorStyle} from "style/SsqEditorStyle";
import {makeDocLanguageString} from "borispage/common/DocumentTabUtil";
import {DocType} from "definitions/DocType";
import {getEncodedStringRemovedUnValidUrl, getHighlightedTextFromHtml, parseSanitize, sanitize} from "util/commonUtils";
import {FeedbackType} from "definitions/FeedbackType";
import img_view_icon_bookmark from "../images/community/view_icon_bookmark.svg";
import img_view_icon_bookmark_on from "../images/community/view_icon_bookmark_on.svg";
import axios from "axios";
import {getstore} from "store/ssqstore";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";
import {ACTION_TYPES} from "store/ActionTypes";
import {langutil} from "language/langutil";
import clsx from "clsx";
import {PopReport} from "docwrite/popup/PopReport";
import svcs from "services";
import {loginutil} from "util/loginutil";
import {ssqutil} from "util/ssqutil";
import {ReqDelPopupWrap} from "docwrite/community/popup/ReqDelPopupWrap";
import {docutil} from "util/docutil";

interface Props extends RouteComponentProps<any> {
  document: ISsqDataDocument;
  previousClickedDocumentId?: number;
  setClickedDocumentIdFunc?: Function;
  ssqDataRepository: SsqDataRepository;
  languageService: LanguageService;
  categoryStore: CategoryStore;
  loadAllCategories: () => void;
  expendAccordion?: boolean;
  loginInfo: IfLoginInfo;
  setIsLoginPopup: Function;
  postNum?: number;
  openToast?: (type: string) => void;
  bookmark?: boolean;
}

interface State {
  selectedVersionItem: IVersion;
  relatedCategories: ICategoryForSearch[];
  clickCount: number;
  feedbackGood: boolean;
  feedbackBad: boolean;
  feedbackComment: string;
  isBookmark: boolean;
  viewMorePost: boolean;
  bookMarkHover: boolean;
  shareHover: boolean;
  downloadHover: boolean;
  toastPopUp: boolean;
  moreHover: boolean;
  shareClick: boolean;
  seq: number;
  toastType: string;
}


class SsqDocumentsAccordionItem extends Component<Props, State> {
  popReport: React.RefObject<PopReport>;
  outSideClickPost: React.RefObject<HTMLInputElement>;
  private readonly refPopDelReq: React.RefObject<{ show: ({doc: ISsqDataDocumentAdminPopup}) => Promise<any> }>;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedVersionItem: this.getFirstVersion(),
      relatedCategories: [],
      clickCount: this.props.document.clickCount,
      feedbackGood: true,
      feedbackBad: false,
      feedbackComment: "",
      isBookmark: false,
      viewMorePost: false,
      bookMarkHover: false,
      shareHover: false,
      downloadHover: false,
      toastPopUp: false,
      moreHover: false,
      shareClick: false,
      seq: 0,
      toastType: '',
    };
    this.popReport = React.createRef();
    this.outSideClickPost = React.createRef();
    this.refPopDelReq = React.createRef();
    this.handleClickOutsidePost = this.handleClickOutsidePost.bind(this);
  }

  async deleteApprReqDocument(country, lang) {
    this.refPopDelReq.current.show({doc: this.props.document}).then(res => {
      window.open(`/${country}/${lang}/product/category/0`, '_self');
      console.log("res", res);
    }).catch(e => {
      console.error("E", e);
    });
  }

  async componentDidMount() {
    await this.props.loadAllCategories();
    this.setDocumentData();

    axios.post(`/api/guest/ssqData/bookmark/check`, {
      userId: getstore().getState().main.loginInfo.userId,
      docId: this.props.document.id
    }).then(response => {
      if (response.data) {
        this.setState({isBookmark: true});
      }
    });
    document.addEventListener('mousedown', this.handleClickOutsidePost);
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.document.id !== this.props.document.id) {
      this.setDocumentData();
    }
  }

  handleClickOutsidePost(e: MouseEvent) {
    if (this.outSideClickPost.current && !this.outSideClickPost.current.contains(e.target as Node)) {
      this.setState({viewMorePost: false});
    }
  }


  setDocumentData() {
    this.setState({
      selectedVersionItem: this.getFirstVersion(),
      relatedCategories: this.props.document.categories
        .map(categoryId => this.props.categoryStore.getCategorySearchItemById(categoryId))
        .sort((a, b) => {
          if (a.parentsCategory < b.parentsCategory) {
            return -1;
          }
          if (a.parentsCategory > b.parentsCategory) {
            return 1;
          }
          return 0;
        })
    });
  }

  getTranslation(key: string): string {
    this.props.languageService.setNamespace("I18N_NAMESPACE_PRODUCT_PAGE");
    return this.props.languageService.getTranslationByKey(key) || "";
  }

  getFirstVersion(): IVersion {
    return this.props.document.versions.length > 0 &&
      this.props.document.versions[0] ||
      emptyVersion;
  }

  // getDownloadUrl = (file: IFile) => {
  //   if (file.fileKey && file.fileName) {
  //     return `/uploads/${file.fileKey}/${getEncodedStringRemovedUnValidUrl(file.fileName)}?type=attachment`;
  //   } else {
  //     return "";
  //   }
  // };

  getZipFileName(): string {
    return this.props.document.docTitle + "_" + this.state.selectedVersionItem.version + ".zip";
  }

  downloadFile(blob: Blob, zipFileName: string) {
    download(blob, zipFileName, "application/zip");
  }

  // async onClickMultipleDownloadButton() {
  //   const blob = await this.props.ssqDataRepository.downloadZipFile(this.state.selectedVersionItem.files);
  //   await this.props.ssqDataRepository.addDownloadCount(
  //     this.state.selectedVersionItem.files.map(file => file.id)
  //   );
  //   this.downloadFile(blob, this.getZipFileName());
  // }

  copyToClipboardCurrentUrl(documentId: number) {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    const trans = this.getTranslation.bind(this);
    if (!document.queryCommandSupported("copy")) {
      //return alert("복사 기능이 지원되지 않는 브라우저입니다.");
      return alert(trans('I18N_BROWSER_DOES_NOT_SUPPORT'));
    }

    let dummy = document.createElement("input");
    let url = window.location.protocol + "//" + window.location.host + `/${country}/${lang}/product/document/` + documentId;

    document.body.appendChild(dummy);
    dummy.value = url;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);

    //window.alert("현재 웹페이지의 주소(URL)가 클립보드에 복사되었습니다.");
    //window.alert(trans('I18N_URL_COPIED_TO_CLIPBOARD'));
  }

  async postUserDownload(downloadType: string) {
    let createUserDownloadRequest: ICreateUserDownloadRequest = {
      ...emptyCreateUserDownloadRequest,
      documentId: this.props.document.id,
      docTitle: this.props.document.docTitle,
      docType: this.props.document.docType,
      updateTime: new Date()
    };

    if (downloadType === DownloadType.VERSION) {
      createUserDownloadRequest = {
        ...createUserDownloadRequest,
        downloadType: DownloadType.VERSION,
        versionName: this.state.selectedVersionItem.version,
      };
    } else if (downloadType === DownloadType.FILE) {
      createUserDownloadRequest = {
        ...createUserDownloadRequest,
        downloadType: DownloadType.FILE,
        fileKey: this.state.selectedVersionItem.files[0].fileKey,
        fileName: this.state.selectedVersionItem.files[0].fileName,
      };
    }

    await this.props.ssqDataRepository.postUserDownload(createUserDownloadRequest);
  }

  async postUserDownloadByFile(downloadFile: IFile) {
    let createUserDownloadRequest: ICreateUserDownloadRequest = {
      ...emptyCreateUserDownloadRequest,
      documentId: this.props.document.id,
      docTitle: this.props.document.docTitle,
      docType: this.props.document.docType,
      downloadType: DownloadType.FILE,
      fileKey: downloadFile.fileKey,
      blobUrlForLargeFile: downloadFile.blobUrlForLargeFile,
      fileName: downloadFile.fileName,
      updateTime: new Date(),
    };

    await this.props.ssqDataRepository.postUserDownload(createUserDownloadRequest);
  }

  async postUserShare(document: ISsqDataDocument) {
    const createUserShareRequest: ICreateUserShareRequest = {
      documentId: document.id,
      userId: "set userId in BFF",
      docType: document.docType,
      docTitle: document.docTitle,
      updateTime: new Date()
    };

    await this.props.ssqDataRepository.postUserShare(createUserShareRequest);
  }

  renderBookMarkHover() {
    return <div className={"bookmark-hover"} onMouseEnter={(e) => {
      e.stopPropagation();
      this.setState({bookMarkHover: true});
    }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        this.setState({bookMarkHover: false});
      }}>
      {this.getTranslation('I18N_DOC_COL_BOOKMARK')}
    </div>;
  };

  renderShareHover() {
    return <div className={"share-hover"} onMouseEnter={(e) => {
      e.stopPropagation();
      this.setState({shareHover: true});
    }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        this.setState({shareHover: false});
      }}>
      {this.getTranslation('I18N_DOC_COL_SHARE')}
    </div>;
  };

  renderDownloadHover() {
    return <div className={"download-hover"}>
      {this.getTranslation('I18N_TAB_DOWNLOAD')}
    </div>;
  };

  renderMoreHover() {
    return <div className={"more-hover"} onMouseEnter={(e) => {
      e.stopPropagation();
      this.setState({moreHover: true});
    }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        this.setState({moreHover: false});
      }}>
      {this.getTranslation('I18N_DOC_VIEW_MORE')}
    </div>;
  };

  renderVersion() {
    const {document} = this.props;
    return <InputWrapForSelect>
      {this.state.selectedVersionItem.version !== NO_VERSION_TAG ?
        <div className={"version-select-wrap"} onClick={(e) => {
          e.stopPropagation();
        }}>
          <select
            aria-label={`select-version-${document.id}`}
            onChange={(event) => {
              this.setState({selectedVersionItem: document.versions[event.target.selectedIndex]});
            }}>
            {document.versions.map((versionItem: IVersion, index) => {
              return <option key={index}
                value={`version-${versionItem.version}`}
              >{versionItem.version}</option>;
            })}
          </select>
        </div>
        :
        <div className={"version-select-wrap"}>
          <span>-</span></div>
      }
    </InputWrapForSelect>;

  }

  renderSpotMore() {
    const {document} = this.props;

    return <div>
      {this.props.loginInfo.userId === this.props.document.writerId ?
        <div className="list-modify-body" ref={this.outSideClickPost} onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}>
          <button className="btn-list-modify"
            onMouseEnter={(e) => {
              e.stopPropagation();
              this.setState({moreHover: true});
            }}
            onMouseLeave={(e) => {
              e.stopPropagation();
              this.setState({moreHover: false});
            }}
            onClick={(e) => {
              e.stopPropagation();
              this.viewMoreButton();
            }}>
          </button>
          {this.state.moreHover && this.renderMoreHover()}

          <div className={clsx("modify-item-body")}
            style={{display: this.state.viewMorePost ? 'inline-block' : ''}}>
            <button className={clsx("modify-btn modify")}
              onClick={(e) => {
                e.stopPropagation();
                this.handleClick('modifyPost', 'modifyPost');
                this.setState({viewMorePost: false});
              }}
            >{this.getTranslation('I18N_PRODUCT_DOC_MODIFIED')}
            </button>
            <button className={clsx("modify-btn modify")}
              onClick={(e) => {
                e.stopPropagation();
                this.handleClick('deletePost', 'deletePost');
                this.setState({viewMorePost: false});
              }}
            >{this.getTranslation('I18N_PRODUCT_DOC_DELETE')}
            </button>
          </div>
        </div>
        :
        loginutil.islse(this.props.loginInfo) ?
          <div className="list-modify-body" ref={this.outSideClickPost} onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}>
            <button className="btn-list-modify"
              onMouseEnter={(e) => {
                e.stopPropagation();
                this.setState({moreHover: true});
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                this.setState({moreHover: false});
              }}
              onClick={(e) => {
                e.stopPropagation();
                this.viewMoreButton();
              }}>
            </button>
            {this.state.moreHover && this.renderMoreHover()}
            <div className={clsx("modify-item-body")}
              style={{display: this.state.viewMorePost ? 'inline-block' : ''}}>

              <button className={clsx("modify-btn modify")}
                onClick={(e) => {
                  e.stopPropagation();

                  this.setState({viewMorePost: false});
                  this.handleClick('reportDoc', document.id);
                }}
              >{this.getTranslation('I18N_PRODUCT_DOC_REPORT')}
              </button>
              <button className={clsx("modify-btn modify")}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleClick('modifyPost', 'modifyPost');
                  this.setState({viewMorePost: false});
                }}
              >{this.getTranslation('I18N_PRODUCT_DOC_MODIFIED')}
              </button>
            </div>
            <PopReport ref={this.popReport} trans={this.getReportTrans} ssqDataRepository={this.props.ssqDataRepository}
              languageService={this.props.languageService}/>
          </div>
          :
          <div className="list-modify-body" ref={this.outSideClickPost} onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}>
            <button className="btn-list-modify"
              onMouseEnter={(e) => {
                e.stopPropagation();
                this.setState({moreHover: true});
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                this.setState({moreHover: false});
              }}
              onClick={(e) => {
                e.stopPropagation();
                this.viewMoreButton();
              }}>
            </button>
            {this.state.moreHover && this.renderMoreHover()}
            <div className={clsx("modify-item-body")}
              style={{display: this.state.viewMorePost ? 'inline-block' : ''}}>

              <button className={clsx("modify-btn notify modify")}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({viewMorePost: false});
                  this.handleClick('reportDoc', document.id);
                }}
              >{this.getTranslation('I18N_PRODUCT_DOC_REPORT')}
              </button>
            </div>
            <PopReport ref={this.popReport} trans={this.getReportTrans} ssqDataRepository={this.props.ssqDataRepository}
              languageService={this.props.languageService}/>
          </div>
      }
      <div className="mobile-black" style={{display: this.state.viewMorePost ? 'block' : 'none'}}></div>
    </div>;

  }

  getReportTrans(key: string): string {
    svcs.svcLang.setNamespace("I18N_NAMESPACE_ADMIN_PAGE");
    return svcs.svcLang.getTranslationByKey(key) || "";
  }

  viewMoreButton() {
    console.log("-- viewMorePostOn", this.state.viewMorePost);
    this.setState({viewMorePost: !this.state.viewMorePost});
  }

  handleClick(cmd: string, data?) {
    const document = this.props.document;
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());

    switch (cmd) {
      case "modifyPost" :
        if (document.docType === DocType.MANUAL || document.docType === DocType.CATALOG || document.docType === DocType.SOFTWARE ||
          document.docType === DocType.OS || document.docType === DocType.CAD_DATA ||
          document.docType === DocType.CERTIFICATION || document.docType === DocType.DATASHEET ||
          document.docType === DocType.EDUCATION_NOTE || document.docType === DocType.EDUCATION_VIDEO || document.docType === DocType.EDUCATION_INTERNAL ||
          document.docType === DocType.TROUBLE_SHOOTING) {
          window.open(`/${country}/${lang}/community/new/${this.props.document.id}?docgrp=product`);
        } else if (document.docType === DocType.APPLICATION_NOTE || document.docType === DocType.TECHNICAL_GUIDE) {
          window.open(`/${country}/${lang}/community/new/${this.props.document.id}?docgrp=blog`);
        }
        return console.log('modifyPost: ', this.props.document.id);

      case 'deletePost' :
        if (docutil.approvalRequried(document.docType)) {
          this.deleteApprReqDocument(country, lang).then(res => {
            console.log("res", res);
          });
        } else {
          if (confirm(this.getTranslation('I18N_PRODUCT_DOC_CONFIRM_DELETE'))) {
            this.props.ssqDataRepository.deleteCommunityDocument(this.props.document.id).then(r => {
              if (r === 200) {
                alert(this.getTranslation("I18N_PRODUCT_DOC_CONFIRM_DELETE_SUCCESS"));
                window.open(`/${country}/${lang}/product/category/0`, '_self');
              } else {
                alert(this.getTranslation("I18N_PRODUCT_DOC_ERROR_DELETE"));
              }
            });
          }
        }
        break;

      case 'reportDoc':
        this.props.loginInfo.userId === undefined ?
          this.props.setIsLoginPopup(true)
          :
          this.popReport.current.show({docId: this.props.document.id, reportType: 'DOC'})
            .then(res => {
              console.log("res", res);
            }).catch(e => {
            console.error("E", e);
          });
        return console.log("-- reportReviewClick", this.state.viewMorePost);
    }
  }

  getLanguageString(fileLang: string): string {
    switch (fileLang) {
      case DocLanguageType.ALL:
        return this.getTranslation("I18N_FILE_LANG_ALL");
      case DocLanguageType.KO:
        return this.getTranslation("I18N_FILE_LANG_KO");
      case DocLanguageType.EN:
        return this.getTranslation("I18N_FILE_LANG_EN");
      case DocLanguageType.ETC:
        return this.getTranslation("I18N_FILE_LANG_ETC");
      default:
        return "-";
    }
  }

  async updateDownloadCount(fileId: number) {
    await this.props.ssqDataRepository.addDownloadCount([fileId]);
  }

  isEducationArticleType() {
    const docType = this.props.document.docType;

    if (docType === DocType.EDUCATION_VIDEO || docType === DocType.EDUCATION_NOTE || docType === DocType.EDUCATION_INTERNAL)
      return true;

    return false;
  }

  isClickedFeedback() {
    return this.state.feedbackBad || this.state.feedbackGood;
  }

  isCategoryUrl() {
    let url = window.location.href;
    let result = false;

    if (url.includes("/product/category")) {
      result = true;
    } else if (url.includes("/product/document")) {
      result = false;
    } else {
      result = false;
    }

    return result;
  }

  feedbackHandleKeyDown(event: React.KeyboardEvent<HTMLTextAreaElement>, documentId: number) {
    if (event.key === 'Enter' && event.ctrlKey) {
      this.setState({feedbackComment: this.state.feedbackComment + '\n'});
    } else if (event.key === 'Enter') {
      event.preventDefault();
      this.feedbackSubmitEvent(documentId);
    }
  }

  async feedbackSubmitEvent(documentId: number) {
    if (!this.isClickedFeedback()) return;
    if (!this.state.feedbackComment || this.state.feedbackComment.length == 0) return;
    if (!loginutil.islogin(this.props.loginInfo)) return this.props.setIsLoginPopup(true);

    if (confirm(this.getTranslation('I18N_FEEDBACK_CONFIRM'))) {
      let createPostFeedback: ICreatePostFeedback = {
        feedbackType: this.state.feedbackGood ? FeedbackType.GOOD : FeedbackType.BAD,
        comment: this.state.feedbackComment,
        feedbackWriterId: "", // set feedbackWriterId in BFF
        feedbackWriterNickname: "", // set feedbackWriterId in BFF
        documentId: documentId
      };

      await this.props.ssqDataRepository.postFeedback(createPostFeedback).then(() => {
        this.props.openToast('feedback');

        this.setState({
          feedbackGood: false,
          feedbackBad: false,
          feedbackComment: ""
        });
      });
    }
  }

  render() {
    const {document} = this.props;
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());

    return (
      <AccordionContainer>
        <ReqDelPopupWrap ref={this.refPopDelReq}/>
        <AccordionItem dangerouslySetExpanded={this.props.expendAccordion}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <div className={"accordion-row"} onClick={async (e) => {
                if (this.isCategoryUrl()) {
                  if (this.props.previousClickedDocumentId != document.id) {
                    await this.props.ssqDataRepository.addClickCount(document.id);

                    if (this.props.setClickedDocumentIdFunc) {
                      this.props.setClickedDocumentIdFunc(document.id);
                    }
                  }
                }
              }
              }>
                <div className={"accordion-col-doc-num"}>{this.props.postNum}</div>
                <div className={"accordion-col-doc-title"}>
                  <span>{parse(getHighlightedTextFromHtml(document.docTitle))}</span>
                  {/*파트너전용레벨
                  <span className={"partner-level"}>{this.getTranslation("I18N_SOLUTION_PARTNER")}</span>
                  */}
                  {document.displayTarget == 15 &&
                    <div>
                      <span className={"partner-level"}>{this.getTranslation("I18N_SOLUTION_PARTNER")}</span>
                    </div>}
                  {document.displayTarget == 20 &&
                    <div>
                      <span className={"level"}>{this.getTranslation("I18N_SOLUTION_EMPLOYEE_ONLY")}</span>
                    </div>}
                </div>
                {/*<div className={"accordion-col-files"}>*/}
                {/*  {this.renderDownloadColumnOnHeading()}*/}
                {/*</div>*/}
                <div className="accordion-col-doc-bookmark"> {/*renderDownloadColumnOnHeading <- 이 함수안에 있는 내용을 직접 여기로 가져왔습니다.*/}
                  <button onMouseEnter={(e) => {
                    e.stopPropagation();
                    this.setState({bookMarkHover: true});
                  }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      this.setState({bookMarkHover: false});
                    }}>
                    <img alt={"share_icon.svg"}
                      src={this.state.isBookmark || this.props.bookmark ? img_view_icon_bookmark_on : img_view_icon_bookmark}
                      onClick={async (e) => {
                        e.stopPropagation();
                        if (this.props.loginInfo?.userId)
                          axios.post(`/api/guest/ssqData/bookmark/toggle`, {
                            userId: getstore().getState().main.loginInfo.userId,
                            docId: this.props.document.id,
                            isBookmark: !this.state.isBookmark
                          }).then(response => {
                            this.props.openToast(this.state.isBookmark ? 'bookmark' : 'bookmark-clear');
                            this.setState({
                              isBookmark: !this.state.isBookmark,
                              toastPopUp: !this.state.toastPopUp,
                              seq: this.state.seq + 1,
                              toastType: this.state.isBookmark ? 'bookmark' : 'bookmark-clear'
                            });
                          });
                        else this.props.setIsLoginPopup(true);
                        //북마크 추가
                      }}/>
                  </button>
                  {this.state.bookMarkHover && this.renderBookMarkHover()}

                </div>
                <div className="accordion-col-doc-share">
                  <button onMouseEnter={(e) => {
                    e.stopPropagation();
                    this.setState({shareHover: true});
                  }}
                    onMouseLeave={(e) => {
                      e.stopPropagation();
                      this.setState({shareHover: false});
                    }}>
                    <img alt={""} src={SsqImages.common.icon.shareImgBlack()}
                      onClick={async (e) => {
                        e.stopPropagation();

                        this.copyToClipboardCurrentUrl(document.id);
                        await this.postUserShare(document);
                        this.setState({toastType: 'share', seq: this.state.seq + 1});
                        this.props.openToast('share');
                      }}/>
                  </button>
                  {this.state.shareHover && this.renderShareHover()}
                </div>
                {/*<div className={"accordion-col-description"}>*/}
                {/*    <span>{getTextFromHtml(document.description).substr(0, 70)}</span>*/}
                {/*</div>*/}
                <div className={"accordion-col-doc-language"}>
                  {makeDocLanguageString(this.getTranslation.bind(this), document.docLanguages)}
                </div>
                <div className={"accordion-col-update-time"}>
                  {formatSimpleDate(new Date(document.updateTime))}
                </div>
                <div className={"accordion-col-click-count"}>
                  {document.clickCount}
                </div>
                <div className={"accordion-col-more"}>
                  {this.renderSpotMore()}
                </div>
              </div>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <AccordionLeft>
              <AccordionDown
                className={this.state.selectedVersionItem.version == NO_VERSION_TAG && this.state.selectedVersionItem.files.length == 0 ? "accordion-down-empty" : ""}>
                {this.state.selectedVersionItem.version !== NO_VERSION_TAG &&
                  <div className="row">
                    <div className={"accordion-down"}>
                      {this.isEducationArticleType() ? this.getTranslation("I18N_DOC_COL_EDUCATION_VERSION") : this.getTranslation("I18N_DOC_COL_VERSION")}
                      {this.renderVersion()}
                    </div>
                  </div>
                }
                <div className="row">
                  {this.state.selectedVersionItem.files.map((file: IFileHover, index) => {
                    let fileDownloadUrl: string = `/uploads/${file.fileKey}/${getEncodedStringRemovedUnValidUrl(file.fileName)}`;
                    if (file.blobUrlForLargeFile !== null && file.blobUrlForLargeFile !== undefined && file.blobUrlForLargeFile !== "") {
                      fileDownloadUrl = ssqutil.getBlobUrlForLargeFile(file.blobUrlForLargeFile);
                    }
                    return <div className={"accordion-down"} key={index}>
                      <div className={"down-title"}
                        onClick={async () => {
                          await this.updateDownloadCount(file.id);
                          await this.postUserDownloadByFile(file);
                        }}>
                        <a aria-label={`download-${index}`}
                          href={fileDownloadUrl}
                          target={'_blank'}
                        >
                          {file.fileName}</a></div>
                      <div className={"down-icon"}
                        onMouseEnter={(e) => {
                          e.stopPropagation();
                          file.downloadHover = true;
                          this.setState({selectedVersionItem: {...this.state.selectedVersionItem}});
                        }}
                        onMouseLeave={(e) => {
                          e.stopPropagation();
                          file.downloadHover = false;
                          this.setState({selectedVersionItem: {...this.state.selectedVersionItem}});
                        }}
                        onClick={async () => {
                          await this.updateDownloadCount(file.id);
                          await this.postUserDownloadByFile(file);
                        }}>
                        <a aria-label={`download-${index}`}
                          href={fileDownloadUrl + "?type=attachment"}
                        ><img alt={"download_icon.svg"} src={SsqImages.common.icon.downloadImg()}/></a>
                        {file.downloadHover && this.renderDownloadHover()}
                      </div>

                      <div className={"down-info"}>
                        <span>{this.getLanguageString(file.fileLang)}</span>
                        <span>{getFileSize(file.fileSize)}</span>
                        {/*<span>{this.getTranslation("I18N_DOC_DOWNLOAD_COUNT")}<b>{file.downloadCount}</b></span>*/}
                      </div>
                    </div>;
                  })
                  }
                </div>
                {this.state.selectedVersionItem.version !== NO_VERSION_TAG &&
                  <div className={"accordion-version"}>
                    {/*  <div
                      className={"version-tit"}>{this.isEducationArticleType() ? this.getTranslation("I18N_DOC_COL_EDUCATION_VERSION") : this.getTranslation("I18N_DOC_COL_VERSION")}
                      {this.state.selectedVersionItem.version}</div>*/}
                    <div className={"version-desc SsqEditor ck-content"}>{parseSanitize(this.state.selectedVersionItem.versionDescription)}</div>
                  </div>
                }
              </AccordionDown>
              <AccordionDesc>
                <div className={"SsqEditor ck-content"}>
                  <div dangerouslySetInnerHTML={{__html: sanitize(document.description)}}/>
                </div>
              </AccordionDesc>
            </AccordionLeft>
            <AccordionRight>
              <AccordionRelated>
                <div>{this.getTranslation("I18N_DOC_RELATED_CATEGORY")}<img alt={"link_icon.svg"}
                  src={SsqImages.product.linkicon()}/>
                </div>
                <ul>{this.state.relatedCategories.map((relatedCategory, index) => {
                  return <li key={index}>
                    <div className={"related_category_div"}
                      onClick={() => {
                        window.open(`/${country}/${lang}/product/category/${relatedCategory.categoryId}`);
                      }}>
                      {relatedCategory.parentsCategory}
                    </div>
                  </li>;
                })}</ul>
              </AccordionRelated>
              <AccordionFeedback>
                <CommuFeedback>
                  <div className={"title"}>{this.getTranslation("I18N_DOC_FEEDBACK")}</div>
                  <div className={"feedback_btn"}>
                    <div className="feedback_btn_Good">
                      <button
                        className={this.state.feedbackGood ? "clickGood" : ""}
                        onClick={() => {
                          let feedbackBad = this.state.feedbackBad;
                          if (!this.state.feedbackGood) {
                            feedbackBad = false;
                          }
                          this.setState({
                            feedbackGood: !this.state.feedbackGood,
                            feedbackBad
                          });
                        }}
                      >{this.getTranslation("I18N_DOC_FEEDBACK_GOOD")}
                      </button>
                    </div>

                    <div className="feedback_btn_Bad">
                      <button
                        className={this.state.feedbackBad ? "clickBad" : ""}
                        onClick={() => {
                          let feedbackGood = this.state.feedbackGood;
                          if (!this.state.feedbackBad) {
                            feedbackGood = false;
                          }
                          this.setState({
                            feedbackGood,
                            feedbackBad: !this.state.feedbackBad
                          });
                        }}
                      >{this.getTranslation("I18N_DOC_FEEDBACK_BAD")}
                      </button>
                    </div>
                  </div>
                  <div className={"idea-review"}>
                                    <textarea maxLength={250} value={this.state.feedbackComment}
                                      placeholder={this.getTranslation("I18N_DOC_FEEDBACK_PLACEHOLDER")}
                                      onChange={(e) => {
                                        this.setState({feedbackComment: e.target.value});
                                      }}
                                      onKeyDown={(e) => this.feedbackHandleKeyDown(e, document.id)}
                                    />
                    <button className={"submit_button"}
                      onClick={async () => {
                        this.feedbackSubmitEvent(document.id);
                      }}>
                    </button>
                  </div>
                </CommuFeedback>
              </AccordionFeedback>
            </AccordionRight>
          </AccordionItemPanel>
        </AccordionItem>
      </AccordionContainer>
    );
  }
}

export default withRouter(connect(
  (state: any) => ({
    loginInfo: state.main.loginInfo,
  }),
  dispatch => ({
    setIsLoginPopup: (isLoginPopup: boolean) => dispatch({type: ACTION_TYPES.MAIN.IS_LOGIN_POPUP, payload: isLoginPopup}),
  })
)(SsqDocumentsAccordionItem));

const AccordionContainer = styled.div`

  .list-modify-body {
    position: relative;
    display: flex;
    justify-content: center;
    //padding-bottom: 0.2rem;
  }

  .btn-list-modify {
    width: 2rem;
    height: 2rem;
    background-image: url("${SsqImages.community.icon.communitySpotMore}");
    background-repeat: no-repeat;
    background-position: center;
  }

  .modify-item-body {
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
    width: 80px;
    position: absolute;
    right: 1.8rem;
    top: 2.8rem;
    z-index: 2;
    display: none;
  }

  .modify-btn {
    color: #2A2C2F;
    ${fontFamilyMedium};
    font-size: 12px;
    width: 80px;
    height: 48px;
    line-height: 48px;
  }

  .modify-btn:first-child {
    border-radius: 4px 4px 0 0;
    background: #fff;
  }

  .modify-btn:last-child {
    border-radius: 0 0 4px 4px;
    border-top: 1px solid #C7D6EA;
    background: #fff;
  }

  .modify-btn.notify {
    border-radius: .4rem;
    border: none;
  }


  [ class ^= "accordion__heading" ] {
    width: 100%;
  }

  [ class ^= "accordion__button" ]: before {
    display: none;
  }

  [ class ^= "accordion__button" ] {
    width: 100%;
    font-size: 1.2rem;
    line-height: 4.8rem;

    &[aria-expanded~="true"] {
      background: rgba(9, 120, 255, 0.1);
      border-left: solid 1px #90A0B6;
      border-right: solid 1px #90A0B6;
      border-top: solid 2px #407DD8;

      .accordion-col-description {
        span {
          display: none;
        }
      }
    }

    .accordion-row {
      display: flex;
      flex-direction: row;
      width: 100%;
      padding: 0 0 0 2.4rem;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      list-style-type: none;

      > div + div {
        margin-left: 1rem
      }

      > div {
        ${fontFamilyRegular};
      }


      .accordion-col-doc-num {
        width: 4%;
      }

      .accordion-col-doc-title {
        width: 62%;
        color: #2A2C2F;
        font-size: 1.5rem;
        display: flex;
        align-items: center;

        ${fontFamilyMedium}
        .level {
          display: inline-block;
          background: rgb(119, 131, 161);
          color: rgb(255, 255, 255);
          border-radius: 16px;
          margin-top: -0.1rem;
          //width: 4.8rem;
          padding: 0 0.8rem;
          height: 1.8rem;
          line-height: 1.8rem;
          font-size: 9px;
          //font-weight: bold;
          text-align: center;
          vertical-align: middle;
          margin-left: .6rem;
        }

        .partner-level {
          display: inline-block;
          background: #F4B209;
          color: rgb(255, 255, 255);
          border-radius: 16px;
          margin-top: -0.1rem;
          //width: 4.8rem;
          padding: 0 0.8rem;
          height: 1.8rem;
          line-height: 1.8rem;
          font-size: 9px;
          //font-weight: bold;
          text-align: center;
          vertical-align: middle;
          margin-left: .6rem;
        }

        @media screen and (max-width: 764px) {
          flex-wrap: wrap;
          span {
            padding-right: 0.6rem;
          }

          .partner-level {
            margin-left: 0;
            margin-top: 0.2rem;
          }

          .level {
            margin-left: 0;
            margin-top: 0.2rem;
          }
        }

        .search_highlight {
          background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
        }
      }

      .accordion-col-description {
        width: 35%;

        span {
          /*  display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;*/

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
        }
      }

      .accordion-col-doc-language {
        width: 7%;
        margin-left: 1rem;
      }

      .accordion-col-files {
        width: 11%;

        select {
          width: 12rem;
          padding: 0 .8rem;
          background-position: center right .4rem;
        }

        .version-select-wrap {
          display: inline-block;
          width: 12rem;
          margin-right: .5rem
        }

        span + button {
          margin-left: .5rem;
        }

        div > span img {
          vertical-align: middle
        }
      }

      .accordion-col-files button {
        border-radius: 2px;

        a {
          display: block;
        }

        img {
          vertical-align: middle;
        }

        :hover {
          background: rgba(64, 125, 217, 0.1);
        }

        :active {
          background: rgba(64, 126, 219, 0.3);
        }
      }

      .accordion-col-update-time {
        width: 7%;
        font-variant-numeric: tabular-nums;
        letter-spacing: -0.8px;
      }

      .accordion-col-click-count {
        width: 6%;
        text-align: center;
        margin-right: 0;
      }

      :hover {
        background: rgba(64, 126, 219, 0.1);
      }

      :active {
        background: rgba(64, 126, 219, 0.3);
      }

      .acc-on {
        border-left: 1px solid #90A0B6;
        border-right: 1px solid #90A0B6;
        border-top: 2px solid #407DD8;
      }

      .accordion-col-doc-bookmark {
        width: 5%;
        position: relative;
        text-align: center;

        > button {
          //margin-left: 0.5rem;
        }

        img {
          vertical-align: middle
        }
      }

      .accordion-col-doc-share {
        width: 5%;
        position: relative;
        text-align: center;

        img {
          vertical-align: middle
        }
      }

      .accordion-col-more {
        width: 4%;
        padding-right: 2rem;
      }

      .bookmark-hover {
        position: absolute;
        top: -0.5rem;
        left: 50%;
        transform: translateX(-50%);
        background: white;
        border: 0.5px solid #C7D6EA;
        border-radius: 4px;
        height: 1.8rem;
        line-height: 1.6rem;
        min-width: 42px;
        padding: 0 0.6rem;
        text-align: center;
        z-index: 2;
        font-size: 9px;
        white-space: nowrap;
        color: #7783A1;
        ${fontFamilyRegular};
      }

      .share-hover {
        position: absolute;
        top: -0.5rem;
        left: 50%;
        transform: translateX(-50%);
        background: white;
        border: 0.5px solid #C7D6EA;
        border-radius: 4px;
        height: 1.8rem;
        line-height: 1.6rem;
        min-width: 42px;
        padding: 0 0.6rem;
        text-align: center;
        z-index: 2;
        font-size: 9px;
        white-space: nowrap;
        color: #7783A1;
        ${fontFamilyRegular};
      }

      .more-hover {
        position: absolute;
        top: -1.5rem;
        left: 50%;
        transform: translateX(-50%);
        background: white;
        border: 0.5px solid #C7D6EA;
        border-radius: 4px;
        height: 1.8rem;
        line-height: 1.6rem;
        min-width: 42px;
        padding: 0 0.6rem;
        text-align: center;
        z-index: 2;
        font-size: 9px;
        white-space: nowrap;
        color: #7783A1;
        ${fontFamilyRegular};
      }
    }
  }

  [ class ^= "accordion__panel" ] {
    border-bottom: solid 1px #90A0B6;
    border-left: solid 1px #90A0B6;
    border-right: solid 1px #90A0B6;
    font-size: 1.2rem;
    color: #2A2C2F;
    background: #ffffff;

    :after {
      display: block;
      content: '';
      clear: both;
    }

    :not([hidden]) {
      display: flex;
    }
  }

  @media screen and (min-width: 1200px) {
    .accordion-col-doc-title {
      display: flex;

      > span {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
    }
  }

  @media screen and (max-width: 1199px) {
    [class^="accordion__panel"] {
      :not([hidden]) {
        display: block;
      }
    }

    .accordion-row {
      > div {
        margin-right: 0 !important;
      }
    }


    .accordion-col-doc-title {
      line-height: initial;
      padding: 1.5rem 0;
      width: 35% !important;

      > span {
        display: inline;
      }

      > div {
        display: inline;
      }
    }

    .accordion-col-description {
      display: none;
      width: auto
    }

    .accordion-col-update-time {
      width: 7% !important;
    }

    .accordion-col-files {
      //width: 21% !important;
      width: 10% !important;

      .version-select-wrap, select {
        width: 8.8rem !important;
      }
    }

    .accordion-col-doc-language {
      width: 8% !important;
    }

    .accordion-col-click-count {
      width: 6% !important;
      text-align: center;
      margin-right: 0;
    }

    .accordion-col-doc-bookmark {
      width: 7% !important;
    }

  }
  @media screen and (max-width: 764px) {
    [class^="accordion__panel"] {
      font-size: 11px;
    }

    .accordion-col-update-time, .accordion-col-click-count, .accordion-col-doc-language {
      display: none;
      width: auto
    }

    .accordion-col-doc-num {
      width: 8% !important;
    }

    .accordion-col-doc-title {
      //width: calc(100% - 17rem) !important;
      width: 56% !important;
      font-size: 14px !important;
    }

    .accordion-col-doc-bookmark {
      width: 16% !important;
    }

    .accordion-col-doc-share {
      width: 10% !important;
    }

    .accordion-col-more {
      width: 10% !important;
    }

    .accordion-col-files {
      //width: 16rem !important;
      width: 8rem !important;
    }

    .mobile-black {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 9;
      background: rgba(0, 0, 0, .5);
      display: none;
    }

    .modify-btn {
      width: 100%;
      max-width: 20rem;
    }

    .modify-item-body {
      width: 90%;
      position: fixed;
      left: 50%;
      top: 50%;
      max-width: 20rem;
      transform: translate(-50%, -50%);
      z-index: 101;
    }


  }
`;
const AccordionLeft = styled.div`
  width: calc(100% - 32rem);
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  @media screen and (max-width: 1199px) {
    width: 100%
  }
`;
const AccordionDesc = styled.div`
  padding: 2.4rem;
  word-break: keep-all;
  line-height: 2rem;
  min-height: 16rem;

  ${EditorStyle}
  .search_highlight {
    background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
  }
`;
const AccordionDown = styled.div`
  //border-top: 1px dashed #90A0B6;
  border-bottom: 1px dashed #90A0B6;
  padding: 2.4rem;

  ${EditorStyle}
  .version-select-wrap {
    margin-left: 1rem;

    > select {
      min-width: 16rem;
      ${fontFamilyMedium};
      font-size: 1.4rem;
      background-position: center right 0.6rem;
    }
  }

  > div.row {
    margin-bottom: 2.4rem;
  }

  > div.row:last-child {
    margin-bottom: 0;
  }

  &.accordion-down-empty {
    //border-top: none;
    border-bottom: none;
    padding: 0;
    margin-top: 0;
  }

  .accordion-version {
    margin-bottom: 1rem;

    .version-tit {
      color: #666E7A;
      line-height: 2.4rem;
    }

    .version-desc {
      overflow-x: auto;
      ${fontFamilyRegular};
      line-height: 1.5;
    }
  }

  .accordion-down-wrap {
    //border-top: 1px dashed #90A0B6;
    //padding: 2.4rem;
  }

  .accordion-down {
    margin-bottom: .8rem;
  }

  .accordion-down:last-child {
    margin-bottom: 0;
  }

  .accordion-down > div {
    display: inline-block;
  }

  .down-title {
    margin-right: .7rem;

    > a {
      color: #407EDB;
      font-size: 1.6rem;
    }
  }

  .down-icon {
    vertical-align: middle;
    margin-right: .7rem;
    position: relative;

    .download-hover {
      position: absolute;
      top: -1.4rem;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(255, 255, 255, 0.5);
      border: 0.5px solid #C7D6EA;
      border-radius: 4px;
      height: 1.8rem;
      line-height: 1.6rem;
      min-width: 4.2rem;
      white-space: nowrap;
      padding: 0 0.6rem;
      text-align: center;
      cursor: pointer;
      z-index: 2;
      font-size: 9px;
      color: #7783A1;
      ${fontFamilyRegular};
    }
  }

  .down-info {
    color: #7783A1;
  }

  .down-info span:after {
    content: '';
    width: .1rem;
    height: 1.5rem;
    background: #C7D6EA;
    margin: 0 .5rem;
    display: inline-block;
    vertical-align: middle;
  }

  .down-info span:last-child:after {
    display: none;
  }

  .down-info span b {
    color: #407EDB;
    font-weight: normal;
    margin-left: .5rem;
  }

  @media screen and (max-width: 1199px) {
    .accordion-down + .accordion-down {
      margin-top: 1.6rem
    }
  }
`;
const AccordionRelated = styled.div`

  > div img {
    vertical-align: middle;
  }

  ul {
    margin-top: .5rem;
  }

  li {
    color: #407EDB;
    margin: .2rem 0;
  }

  .related_category_div {
    cursor: pointer;
  }

  @media screen and (max-width: 1199px) {
    ul {
      margin-top: .8rem;
    }

    li {
      margin: 0;

      + li {
        margin-top: .8rem
      }
    }
  }
`;
const AccordionRight = styled.div`
  width: 32rem;
  min-height: 100%;
  background: #F7F8FB;
  padding: 2.4rem;
  font-size: 1.2rem;
  @media screen and (max-width: 1199px) {
    width: 100%;
    border-top: solid 1px #C7D6EA;
  }
`;
const AccordionFeedback = styled.div`
  margin-top: 2.4rem;
`;